import React from 'react'
import {CarDeliveryInfo, CarDeliveryIcon, Info, Text, Link} from './style'

const urlCarDelivery = 'https://www.webmotors.com.br/cardelivery/?idcmpint=t1:c17:m07:portal-anuncio-lpcardelivery:cardelivery::saiba-mais:comprar'
const dataTestLabel = 'img_cardelivery'
export default ({ isSimulation = false, text = 'Saiba mais', isModal = false }) =>
  <CarDeliveryInfo data-test-component={dataTestLabel} isSimulation={isSimulation} isModal={isModal}>
    <CarDeliveryIcon src='/assets/img/CarDeliveryLead.svg'/>
    <Info>
      <Text>Receba seu carro em casa.</Text>
      <Link href={urlCarDelivery} target='_blank'>{text}</Link>
    </Info>
  </CarDeliveryInfo>
